import React from 'react'
const SvgProvide6 = props => (
  <svg id='provide6_svg___\u56FE\u5C42_2' data-name='\u56FE\u5C42 2' viewBox='0 0 48.05 48.05' {...props}>
    <defs>
      <style>
        {'.provide6_svg__cls-1,.provide6_svg__cls-2{fill:#334966;stroke-width:0}.provide6_svg__cls-2{fill:#fd5c1f}'}
      </style>
    </defs>
    <g id='provide6_svg___\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
      <path
        id='provide6_svg___\u5F62\u72B6'
        data-name='\u5F62\u72B6'
        className='provide6_svg__cls-1'
        d='M14.02 10.02h20v28h-20v-28zm2 2v24h16v-24h-16z'
      />
      <path
        id='provide6_svg___\u77E9\u5F62'
        data-name='\u77E9\u5F62'
        className='provide6_svg__cls-2'
        d='M18.02 14.02h12v8h-12z'
      />
      <path className='provide6_svg__cls-2' d='M18.02 24.02h12v2h-12zM18.02 28.02h12v2h-12zM18.02 32.02h12v2h-12z' />
      <path
        className='provide6_svg__cls-1'
        d='M4.82 34.78l5.06.56-4.18 4.19C-2.38 30-1.8 15.86 7.03 7.03 15.86-1.8 30-2.38 39.52 5.7L38.1 7.12C29.95.32 18.11.31 9.94 7.09 1.78 13.87-.37 25.52 4.82 34.78zm38.4-21.5l-5.06-.56 4.19-4.19c8.08 9.53 7.5 23.66-1.33 32.49-8.83 8.83-22.97 9.41-32.49 1.33l1.42-1.42c8.15 6.8 19.99 6.81 28.16.03 8.16-6.78 10.32-18.43 5.12-27.69z'
      />
    </g>
  </svg>
)
export default SvgProvide6
